function normalizeIds(value) {
  return Array.from(new Set((Array.isArray(value) ? value : [value])
    .map(Number)
    .filter((id) => Number.isFinite(id) && id > 0)
    .map(Math.trunc)));
}

export function reconcileCampaignHeroAssets({ assetsReady, availableAssetIds, heroAssetIds, selectedAssetId }) {
  const requestedIds = normalizeIds(heroAssetIds?.length ? heroAssetIds : selectedAssetId);
  if (!assetsReady) {
    return { pending: true, heroAssetIds: requestedIds, selectedAssetId: requestedIds[0] || null };
  }
  const availableIds = normalizeIds(availableAssetIds);
  const availableSet = new Set(availableIds.map(String));
  const retainedIds = requestedIds.filter((id) => availableSet.has(String(id)));
  const fallbackId = retainedIds[0]
    || (availableSet.has(String(selectedAssetId)) ? Number(selectedAssetId) : null)
    || availableIds[0]
    || null;
  const resolvedIds = retainedIds.length ? retainedIds : (fallbackId ? [fallbackId] : []);
  return { pending: false, heroAssetIds: resolvedIds, selectedAssetId: resolvedIds[0] || null };
}

